// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
        return error.message
    }
    if (typeof error === 'string') {
        return error
    }
    return 'An unknown error occurred'
}
